// extracted by mini-css-extract-plugin
export default {"container":"LoginScreen_container__IEp-G","logoType":"LoginScreen_logoType__CphDD","imgBkg":"LoginScreen_imgBkg__eMWoY","noSelect":"LoginScreen_noSelect__yIcre"};